module.exports = __webpack_public_path__ + "media/Tatiana-Manaois-You-Mean-To-Tell-Me.f779eb1e.mp3";